import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] grid place-items-center px-4 text-center">
      <div>
        <div className="font-display text-7xl font-extrabold text-blue-600">404</div>
        <p className="text-slate-500 mt-3 mb-6">Aradığınız sayfa bulunamadı.</p>
        <Link to="/"><Button className="bg-blue-600 hover:bg-blue-700"><Home className="h-4 w-4 mr-2" /> Anasayfa</Button></Link>
      </div>
    </div>
  );
}
